import { StorageService } from './../../../Services/storage.service';
import { HttpService } from './../../../Services/http.service';
import { HelperService } from './../../../Services/helper.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lang-changes-modal',
  templateUrl: './lang-changes-modal.component.html',
  styleUrls: ['./lang-changes-modal.component.css']
})
export class LangChangesModalComponent implements OnInit {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  langList: any[] = [];
  form: UntypedFormGroup;
  modalReference: NgbModalRef;

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'sm'
  };

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private storage: StorageService,
    private helper: HelperService,
    private http: HttpService) {

    this.form = this.fb.group({
      languages: []
    });
  }

  ngOnInit() {
    this.langList = this.helper.getLangSelectObj();
  }

  setLangToControl() {
    const currentLang = this.currentLang();
    this.getLangControl().setValue(currentLang);
  }

  getLangControl() {
    return this.form.controls['languages'];
  }

  open() {
    this.setLangToControl();
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
  }

  currentLang() {
    return this.translate.currentLang;
  }

  async setLang() {
    const chosenLang = this.getLangControl().value;
    if (chosenLang !== this.currentLang()) {
      await this.http.changeLocale(chosenLang).toPromise();
      this.storage.setLanguage(chosenLang);
      location.reload();
    }
    this.modalReference.close();
  }
}
